import { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BRAND } from "../lib/assets";

const NAV = [
  { to: "/", label: "Uprcse", testid: "nav-uprcse" },
  { to: "/founder", label: "Founder", testid: "nav-founder" },
  { to: "/connect", label: "Connect", testid: "nav-connect" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#CCD6DC]/85 backdrop-blur-md border-b border-black/30"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 h-24 md:h-28 flex items-center justify-between">
        <Link to="/" className="flex items-center group" data-testid="header-logo-link">
          <motion.img
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, ease: [0.22, 0.61, 0.36, 1] }}
            src={BRAND.logo}
            alt="UPRCSE - Design & Brand Consultant"
            className="h-16 md:h-20 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10" data-testid="header-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={item.testid}
              className={({ isActive }) =>
                `ghost-link ${isActive ? "is-active" : ""}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link
            to="/connect"
            className="liquid-btn is-primary"
            data-testid="header-cta"
          >
            Start a Conversation
          </Link>
        </div>

        <button
          className="md:hidden text-black mono-label"
          onClick={() => setMobileOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {mobileOpen ? "[ CLOSE ]" : "[ MENU ]"}
        </button>
      </div>

      {mobileOpen && (
        <div
          className="md:hidden bg-[#CCD6DC] border-t border-black/30"
          data-testid="mobile-menu"
        >
          <div className="px-6 py-8 flex flex-col gap-6">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `ghost-link text-base ${isActive ? "is-active" : ""}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/connect"
              className="liquid-btn is-primary self-start mt-2"
              onClick={() => setMobileOpen(false)}
            >
              Start a Conversation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
